import { LETTER_OPEN_STATUSES, isLetterStatus } from '../Contracts/LetterStatus'

import type { ILetter } from '../Contracts/ILetter'

/** Лист ще відкритий: чернетка, відкладений чи не відправлений (§7.1). */
const isOpen = (letter: ILetter): boolean => isLetterStatus(letter.status) && LETTER_OPEN_STATUSES.includes(letter.status)

/**
 * Лист ще можна змінити (`SPEC-013` §7.8, §11): право — з беку
 * (`_permissions.update`: автор або адміністратор), і лише невідправлений.
 * Ролей фронт не питає.
 */
export const canEditLetter = (letter: ILetter | null): boolean =>
    letter !== null && letter._permissions?.update === true && isOpen(letter)

/** «Відправити» — за `_permissions.send` і лише невідправленому (§9.4, R-08). */
export const canSendLetter = (letter: ILetter | null): boolean =>
    letter !== null && letter._permissions?.send === true && isOpen(letter)
